import DefaultSkeleton from '@mindtickle/skeleton/DefaultSkeleton';

const menuActionLoaderPropData = {
  title: { width: '84%', style: { margin: '4px 0 4px 16px', height: 28 } },
  paragraph: false,
  active: true,
  avatar: false,
};

const MenuActionLoader = () => <DefaultSkeleton {...menuActionLoaderPropData} />;

export default MenuActionLoader;
